<template>
  <component
    :is="isLink ? TheNuxtLink : 'button'"
    v-bind="isLink ? linkProps : buttonProps"
    :class="contextClassName"
    class="inline-flex max-w-full items-center"
  >
    <IconCaret
      v-if="iconPosition === 'prefix'"
      direction="right"
      class="h-6 w-6 basis-6"
    />
    <span
      class="line-clamp-1 max-w-[calc(100%-theme(spacing.6))] text-sm font-bold leading-6"
    >
      <slot />
    </span>
    <IconCaret
      v-if="iconPosition === 'suffix'"
      direction="right"
      class="h-6 w-6 basis-6"
    />
  </component>
</template>

<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router';

  import type { NuxtLinkProps } from '#app';

  interface IProps extends NuxtLinkProps {
    to?: RouteLocationRaw;
    title?: string;
    iconPosition?: 'prefix' | 'suffix';
    disabled?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), {
    to: undefined,
    title: undefined,
    iconPosition: 'suffix',
    disabled: false,
  });

  const TheNuxtLink = resolveComponent('TheNuxtLink');

  const isLink = computed((): boolean => props.to !== undefined);

  const linkProps = computed((): NuxtLinkProps => {
    const { iconPosition, disabled, ...nuxtLinkProps } = props;
    return nuxtLinkProps;
  });

  const buttonProps = computed(() => ({
    type: 'button',
    disabled: props.disabled,
  }));

  const contextClassName = computed((): string => {
    if (props.disabled) {
      return 'text-gray-400 hover:text-gray-400 pointer-events-none';
    }
    return 'text-blue-400 hover:text-blue-500 hover:underline cursor-pointer';
  });
</script>
